<div class="animate__animated animate__fadeIn">

  <div class="validation-modal-header mb-2">
    <div class="header-info">
      <h3>Grupo de Validación</h3>
      <h2>Editar grupo de validación</h2>
    </div>
    <button type="button" class="btn-close-custom" (click)="onCancel()">
      <i class="material-icons">close</i>
    </button>
  </div>
  <p class="mb-1" style="color: var(--gl-text-secondary);">
    Edite el grupo de validación y verifique que las unidades generadas coincidan con la configuración definida.
  </p>


  <form [formGroup]="editor.form" (ngSubmit)="onSubmit()">
    <!-- Datos Generales -->
    <div class=" border-0 py-2 mb-2" style="border-radius: 12px;">
      <div class="row">
        <div class="mb-0 col-md-9">
          <label class="text-form-label mb-1">
            Nombre del Grupo de Validación <span class="text-danger">*</span>
          </label>
          <input type="text" formControlName="name" class="text-input-clean"
            [class.is-invalid]="submitted && f.name?.invalid" placeholder="Escribe el nombre del grupo...">
          <div *ngIf="submitted && f.name?.hasError('required')" class="validation-error-msg">
            El nombre del grupo es obligatorio
          </div>
        </div>
        <div class="mb-0 col-md-3">
          <label class="text-form-label mb-1">
            Fecha de validación <span class="text-danger">*</span>
          </label>
          <p-calendar formControlName="validationDate" [class.is-invalid-input]="submitted && f.validationDate?.invalid"
            dateFormat="dd/mm/yy" [appendTo]="'body'">
          </p-calendar>
          <div *ngIf="submitted && f.validationDate?.hasError('required')" class="validation-error-msg">
            La fecha es obligatoria
          </div>
        </div>

        <!-- <div class="mb-0 col-md-3">
          <label class="form-label fw-bold text-dark mb-1" style="font-size: 1rem;">
            Tipo de Validación <span class="text-danger">*</span>
          </label>
          <p-dropdown
            formControlName="typeValidation"
            [options]="editor.fleetChecklistTypeOptions"
            optionLabel="name"
            optionValue="value"
            placeholder="Seleccionar"
            [showClear]="true"
            [style]="{width: '100%'}"
            [appendTo]="'body'"
            [class.is-invalid-input]="submitted && f.typeValidation?.invalid">
          </p-dropdown>


          <div *ngIf="submitted && f.typeValidation?.hasError('required')" class="validation-error-msg">
            El tipo es obligatorio
          </div>
        </div> -->

      </div>
    </div>

    <!-- Panel de Filtros Jerárquicos -->
    <div class="dual-list-container">

      <!-- COLUMNA IZQUIERDA: VEHÍCULOS DISPONIBLES (Cuadrilla/Grid) -->
      <div class="list-column">
        <app-validation-vehicle-available></app-validation-vehicle-available>
      </div>

      <!-- COLUMNA DERECHA: VEHÍCULOS SELECCIONADOS (Cuadrilla/Grid) -->
      <div class="list-column" [class.is-invalid-column]="submitted && f.vehicles?.hasError('required')">
        <app-validation-vehicle-selection></app-validation-vehicle-selection>
      </div>
    </div>

    <div class="mb-3 text-end d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-standar" (click)="onCancel()">
        Cancelar
      </button>
      <button class="btn btn-standar btn-standar-success" type="submit">
        <i class="material-icons" style="font-size: 18px;">check_circle</i> Confirmar y Editar Grupo
      </button>
    </div>


  </form>

</div>
